import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { ColorPickerField } from '../../../../ColorPicker'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import { LABEL_FORM_FIELD_NAME_COLOR } from '../../LabelForm.constants'

import { getColorPickerFormikValueProps } from './ColorField.utils'

function ColorField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      Component={ColorPickerField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Label.ColorFieldLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      getValueProps={getColorPickerFormikValueProps}
      name={LABEL_FORM_FIELD_NAME_COLOR}
      placeholder={t('Label.ColorFieldPlaceholderKey')}
      valueLabelTextKey='Label.ColorFieldLabelKey'
    />
  )
}

export default ColorField
